import { useCallback, useState } from 'react';
import { httpPatch } from '../../../../components/utils';

interface Params {
    onSuccess?: (incidentIds: string[], status: number) => void;
    onError?: () => void;
    returnIncidentDataWithSummary?: boolean;
}

const useIncidentStatusUpdate = ({ onSuccess, onError, returnIncidentDataWithSummary }: Params) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [error, setError] = useState<string>();

    const updateIncidentStatus = useCallback(
        async (incidentIds: string[], status: number) => {
            setIsLoading(true);
            setIsSuccessful(false);
            setError(undefined);

            try {
                await httpPatch(`/incidents/updateStatus`, {
                    incidentIds,
                    status,
                    returnIncidentDataWithSummary
                });

                onSuccess?.(incidentIds, status);
                setIsSuccessful(true);
            } catch (err) {
                setError('Failed to update incident status');
                onError?.();
            }

            setIsLoading(false);
        },
        [onSuccess, onError]
    );

    return { mutate: updateIncidentStatus, isLoading, isSuccessful, error };
};

export default useIncidentStatusUpdate;
